<template>
	<div class="modal-prices">

    <div class="modal fade" id="modalEditContract" tabindex="-1" role="dialog" aria-labelledby="modalEditContractLabel" aria-hidden="true">
      <div class="modal-dialog modal-edit-contract" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalEditContractLabel"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">            
            <form-contracts :client="client" :_contract="contract" v-if="contract != null"/>      
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
import FormContracts from './../form-contracts/form-contracts.vue'
import { mapState } from 'vuex'
export default {
	name: 'ModalEditContract',
  props: ['client', 'contract'],
  components: {
    'form-contracts': FormContracts
  },
	methods: {

	},
	data() {
		return {

		}
	},
	created () {

	},

}
</script>
<style scoped>
  .modal-edit-contract{
    width: 90%;
  }
</style>